import React from 'react';
import MaterialHotfilterHeader from './material-hotfilter-header/material-hotfilter-header';
import styles from './catalog-material-hotfilter.module.scss';
import MaterialMenuList from './material-menu-list/material-menu-list';

const CatalogMaterialHotfilter = () => {
  return (
    <div className={styles.catalogMaterialHotfilter__wrapper}>
      <MaterialHotfilterHeader />
      <div className={styles.catalogMaterialHotfilter__scrollContainer}>
        <MaterialMenuList />
      </div>
    </div>
  );
};

export default CatalogMaterialHotfilter;
